export * from './auth.guard';



// WEBPACK FOOTER //
// ./src/app/core/guards/index.ts